import { all } from 'redux-saga/effects';

import AuthSaga from './auth/login/saga';
import LayoutSaga from './layout/saga';
import MemberSaga from './member/saga';
import PermissionSaga from './permission/saga';

export default function* rootSaga() {
    yield all([
        AuthSaga(),
        LayoutSaga(),
        MemberSaga(),
        PermissionSaga(),
    ])
}